<div class="facial-field">
  <div v-if="local_error" class="facial-alert" role="alert">
    {{ local_error }}
  </div>

  <section v-if="step === 1" class="facial-card facial-upload-card">
    <div class="facial-card-heading">
      <div>
        <h4>Upload your identity document</h4>
        <p>Use a clear image where the portrait is visible and in focus.</p>
      </div>
    </div>

    <input
      ref="file_input"
      class="facial-hidden-input"
      type="file"
      accept="image/jpeg,image/png,image/webp"
      @change="on_id_selected"
    />

    <button type="button" class="facial-drop-zone" @click="choose_id">
      <img v-if="id_preview_url" :src="id_preview_url" alt="Selected identity document preview" />
      <template v-else>
        <strong>Select an ID image</strong>
        <small>JPEG, PNG or WebP. Maximum 8 MB.</small>
      </template>
    </button>

    <button type="button" class="facial-primary-button" :disabled="!can_upload_id" @click="upload_id">
      {{ loading ? 'Checking ID image...' : 'Continue to camera' }}
    </button>
  </section>

  <section v-else-if="step === 2 || step === 3" class="facial-capture-layout">
    <div class="facial-card facial-camera-card">
      <div :class="['facial-camera-stage', current_challenge_class]">
        <video ref="video" autoplay muted playsinline></video>
        <div class="facial-camera-shade"></div>
        <div class="facial-face-guide"></div>
        <div v-if="current_challenge?.code === 'MOVE_LEFT'" class="facial-target facial-target-left">LEFT</div>
        <div v-if="current_challenge?.code === 'MOVE_RIGHT'" class="facial-target facial-target-right">RIGHT</div>
        <div v-if="countdown" class="facial-countdown">{{ countdown }}</div>
        <div v-if="!camera_ready" class="facial-camera-placeholder">
          <strong>Camera is off</strong>
          <small>Your browser will ask for permission.</small>
        </div>
      </div>

      <div class="facial-capture-instruction">
        <small>{{ step === 3 ? `Challenge ${challenge_index + 1} of ${session?.challenges?.length || 0}` : 'Camera setup' }}</small>
        <strong>{{ current_challenge?.instruction || (camera_ready ? 'Keep your face inside the oval' : 'Enable your front camera') }}</strong>
      </div>
    </div>

    <aside class="facial-card facial-checklist-card">
      <h4>Before you start</h4>
      <ul>
        <li>Face a light source</li>
        <li>Remove heavy glare</li>
        <li>Keep only one face visible</li>
        <li>Follow each movement slowly</li>
      </ul>

      <div v-if="session?.challenges?.length" class="facial-challenge-preview">
        <small>Your random sequence</small>
        <div v-for="(challenge, index) in session.challenges" :key="`${question.id}-${challenge.code}-${index}`">
          <span>{{ index + 1 }}</span>
          {{ challenge.label }}
        </div>
      </div>

      <button v-if="!camera_ready" type="button" class="facial-primary-button" :disabled="loading" @click="start_camera">
        {{ loading ? 'Starting camera...' : 'Enable camera' }}
      </button>
      <button v-else-if="step === 2" type="button" class="facial-primary-button" :disabled="!can_start_capture" @click="run_capture">
        Start live check
      </button>
      <div v-else class="facial-processing-line">
        {{ status_message }}
      </div>
    </aside>
  </section>

  <section v-else-if="step === 4 && result" class="facial-result-layout">
    <div :class="['facial-card', 'facial-result-summary', result_tone]">
      <p class="facial-eyebrow">Verification result</p>
      <h4>{{ result.decision }}</h4>
      <p v-if="result.decision === 'PASS'">The active challenges and selfie to ID comparison passed.</p>
      <p v-else-if="result.decision === 'REVIEW'">The capture needs a human review or another attempt.</p>
      <p v-else>The capture did not satisfy one or more checks.</p>
    </div>

    <div class="facial-card facial-score-card">
      <div v-for="([label, signal]) in score_rows" :key="`${question.id}-${label}`" class="facial-score-row">
        <div>
          <strong>{{ label }}</strong>
          <small>{{ signal?.decision || 'N/A' }}</small>
        </div>
        <b>{{ score_percent(signal?.score) }}</b>
      </div>

      <button type="button" class="facial-secondary-button" @click="restart">
        Run again
      </button>
    </div>
  </section>
</div>
